import { Injectable, inject } from '@angular/core';

import { BetSlipType } from '@bpos';
import {
    LDFeatureFlags,
    LIVE_ALERTS_ENABLED_FOR_NUMBER_OF_EVENTS_IN_MULTI_BET,
    LIVE_ALERTS_ENABLED_FOR_NUMBER_OF_EVENTS_IN_SINGLE_BET,
    LIVE_ALERTS_ENABLED_FOR_NUMBER_OF_EVENTS_IN_SYSTEM_BET,
} from '@frontend/sports/launch-darkly/feature';

import { AlertToastMessagesService } from '../alert-toast-messages.service';
import { AlertTrackingService } from '../alert-tracking.service';
import { LaunchDarklyAlertsService } from '../launch-darkly-alerts-service';
import { Action, AlertEvent, Mode, Subscription } from '../model';

@Injectable({ providedIn: 'root' })
export class AlertSelectorService {
    private toastMessageService = inject(AlertToastMessagesService);

    mode: Mode;
    model: AlertEvent[];
    source: string;
    private subscribed: boolean;
    private toast?: Function;
    private readonly launchDarklyAlertsService = inject(LaunchDarklyAlertsService);
    private readonly alertTrackingService = inject(AlertTrackingService);

    showSelector(multi: boolean, source: string, selected: boolean): void {
        delete this.toast;
        this.mode = Mode[multi ? 'Multi' : 'Single'];
        this.source = source;
        this.subscribed = selected;
    }

    confirm(subscriptions?: Subscription[], trackLiveAlertsInMyBets = false): void {
        if (subscriptions) {
            const newSubscribed = subscriptions.filter((_) => _.action === Action.Subscribe).length;
            if (newSubscribed) {
                this.toast = this.toastMessageService.showSubscribedToast.bind(this.toastMessageService);
                this.alertTrackingService.trackAlertsSuccess(this.model, true, this.source);
            }
            if (this.subscribed && !this.model.filter((_) => _.selected).length) {
                this.toast = this.toastMessageService.showUnsubscribedToast.bind(this.toastMessageService);
                this.alertTrackingService.trackAlertsSuccess(this.model, false, this.source);
            }
            if (newSubscribed && trackLiveAlertsInMyBets) {
                this.trackMetricsForLiveAlertsActiveEvents(newSubscribed);
            }
        }

        this.toast?.();
    }

    private trackMetricsForLiveAlertsActiveEvents(newSubscribedCount: number): void {
        const betType = this.model[0]?.betType;

        const eventMap: Record<BetSlipType, string> = {
            [BetSlipType.Single]: LIVE_ALERTS_ENABLED_FOR_NUMBER_OF_EVENTS_IN_SINGLE_BET,
            [BetSlipType.Combo]: LIVE_ALERTS_ENABLED_FOR_NUMBER_OF_EVENTS_IN_MULTI_BET,
            [BetSlipType.System]: LIVE_ALERTS_ENABLED_FOR_NUMBER_OF_EVENTS_IN_SYSTEM_BET,
        };

        if (betType && eventMap[betType]) {
            this.launchDarklyAlertsService.track(LDFeatureFlags.EnableLiveAlerts, eventMap[betType], newSubscribedCount);
        }
    }
}
